<template>
  <div>
    <div class="uk-cover-container">
      <BannerComponent :banner-url="`${ASSETS_BASE_URL}/images/properties/backdrop.jpg`" :title="'properties'|translate"/>
    </div>
    <div class="uk-container SectionOne">
      <p class="uk-text-center Description">
        {{'our_collections.para_1'|translate}}
      </p>
      <div class="uk-child-width-expand@m" uk-grid>
        <div class="uk-grid-item-match">
          <router-link to="/casamia-nilaveli">
            <div class="uk-cover-container uk-inline-clip uk-transition-toggle" tabindex="0">
              <canvas height="250"></canvas>
              <img :src="`${ASSETS_BASE_URL}/images/home/img_1.jpg`" alt="" uk-cover style="padding-left: 10px">
              <div class="uk-transition-slide-bottom uk-position-bottom uk-overlay uk-overlay-default Link">
                <router-link class="uk-h4 uk-margin-remove" to="/casamia-nilaveli">CASAMIA Nilaveli</router-link>
              </div>
            </div>
          </router-link>
        </div>
        <div class="uk-grid-item-match">
          <router-link to="/casamia-colombo">
            <div class="uk-cover-container uk-inline-clip uk-transition-toggle" tabindex="0">
              <canvas height="250"></canvas>
              <img :src="`${ASSETS_BASE_URL}/images/home/img_6.jpg`" alt="" uk-cover style="padding-left: 10px">
              <div class="uk-transition-slide-bottom uk-position-bottom uk-overlay uk-overlay-default Link">
                <router-link class="uk-h4 uk-margin-remove" to="/casamia-colombo">CASAMIA Colombo</router-link>
              </div>
            </div>
          </router-link>
        </div>
        <div class="uk-grid-item-match">
          <router-link to="/turtle-nest">
            <div class="uk-cover-container uk-inline-clip uk-transition-toggle" tabindex="0">
              <canvas height="250"></canvas>
              <img :src="`${ASSETS_BASE_URL}/images/home/img_5.jpg`" alt="" uk-cover>
              <div class="uk-transition-slide-bottom uk-position-bottom uk-overlay uk-overlay-default Link">
                <router-link class="uk-h4 uk-margin-remove" to="/turtle-nest">Turtle Nest Rekawa</router-link>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BannerComponent from '../components/BannerComponent'

export default {
  name: 'Properties',
  components: { BannerComponent }
}
</script>

<style scoped>
  .SectionOne {
    padding-top: 30px;
    padding-bottom: 80px;
  }

  .Link {
    text-align: center;
  }

  .Link > a {
    text-decoration: none;
  }

  .Link > a:hover {
    color: #ca420e;
  }

  .Description {
    font-size: 18px;
    margin-bottom: 60px;
  }

  .uk-inline-clip {
    width: 100%;
  }
</style>
